<div class="fx-col page-padding page-content fx-gap-20">
  @for (ungroupedRole of ungroupedGrantedRoles; track ungroupedRole) {
    <app-crud-table
      [title]="ungroupedRole.roleName"
      [subTitle]="ungroupedRole.roleCode + ':' + ungroupedRole.roleDescription"
      [modelType]="grantsModelType"
      [loading$]="loading$"
      [tableData]="ungroupedRole.users"
      [additionalActions]="additionalActions"
      [updatedRow]="updatedRow">
    </app-crud-table>

    <mat-divider></mat-divider>
  }

</div>
